import { useModalContext } from "../modal/context/ModalProvider";
import { modalName } from "../utils/general";

const useSuccessfulModal = (time, message = "Done Successfully") => {
    const { openModal, closeModal } = useModalContext();

    const handleOpenSuccessfulModal = () => {
        openModal({
            modalName: modalName.SUCCESSFULLY_POPUP,
            message: message,
            transferring: false,
            movingData: {},
            modalSize: "md"
        });
        setTimeout(() => {
            closeModal();
        }, time);
    };

    return handleOpenSuccessfulModal;
};

export default useSuccessfulModal;